<template>
  <div class="login">
    <!-- ヘッダー -->
    <SimpleHeader />

    <div class="login-inner flexcenter">
      <div class="login-controls flexcenter">
        <h3 class="font22">ソースネクストへサインイン</h3>
        <div class="mail flexcenter">
          <input class="login-text" type="text" v-model="email" placeholder="メールアドレス (マイページID)" maxlength="128" @keypress.enter="doLogin">
        </div>
        <div class="password flexcenter">
          <input class="login-text" type="password" v-model="password" placeholder="パスワード (英数半角4～16文字)" maxlength="16" @keypress.enter="doLogin">
          <button class="enter" @click="doLogin"><img src="static/images/icon/svg/ar_r_login.svg" alt="login"></button>
        </div>
        <p class="login-error m0" v-if="message">{{ message }}</p>
        <p>
          <a class="login-anchor" href="https://www.sourcenext.com/sc/users/rem_form?PID=login_form" target="_blank">
            メールアドレス、パスワードをお忘れですか？
          </a>
        </p>
        <p class="inline">
          ソースネクストアカウントをお持ちですか？
        </p>
        <p class="inline">
          <span>></span>
          <a class="login-anchor" href="https://www.sourcenext.com/sc/users/user_reg_auth" target="_blank">
            今すぐ作成
          </a>
        </p>
        <p>
          <a class="login-anchor" href="https://www.sourcenext.com/r/p/rosettastone/eula/" target="_blank">
            Rosetta Stone について
          </a>
        </p>
      </div><!-- login-controls flexcenter -->
    </div><!-- login-inner flexcenter -->
  </div><!-- login -->
</template>

<script>
import SimpleHeader from "@/components/Header";
import common from "@/mixin/common";
import http from "@/mixin/http";
import * as constants from "@/mixin/constants";

export default {
  name: "login",
  props: {
    platformName: String
  },
  data: function() {
    return {
      email: "",
      password: "",
      message: "",
      contentId: this.$route.query.id ? this.$route.query.id : "",
      showDictionary: this.$route.query.showDictionary ? this.$route.query.showDictionary : false
    };
  },
  components: {
    SimpleHeader
  },
  mixins: [
    common,
    http
  ],
  created: function() {
    this.log("Login start created");
    this.log("contentId: " + this.contentId);
  },
  mounted: function() {
    this.log("Login start mounted");

    // GoogleAnalyticsページビューヒット送信
    rosettaGA.sendPageView(constants.GA_PAGEVIEW.TITLE.LOGIN, constants.GA_PAGEVIEW.PAGE.LOGIN);

    // ローカルストレージ操作初期化処理
    storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN);

    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1) {
      this.fixtHeightForSafariFullWindow();
    }
  },
  methods: {
    /**
     * ログイン処理実行
     */
    doLogin: function() {
      var self = this;
      self.log("Login start doLogin");

      // メールアドレスの先頭末尾の空白を除去
      self.email = self.email.trim();

      // ログインAPIを実行
      self.login(self.email, self.password, self.contentId).then(function(response) {
        self.log("Login login result_code: " + response.result_code);
        switch (response.result_code) {
          case "OK":
            self.log("Login login access_key: " + response.access_key);
            self.log("Login login url: " + response.url);

            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventLogin(constants.GA_EVENT.ACTION.SUCCESS);

            if (self.isPlatformiOS(self.platformName)) {
              // モバイルアプリのユーザ登録処理メソッドを実行
              window.Phone.RegisterUser(response.access_key);
            } else {
              storage_wrapper.setRsAccessKey(response.access_key);

              if (self.showDictionary) {
                var route = { name: "Dictionary" };
                if (self.isEnvironmentPc()) {
                  self.$router.replace(route);
                } else {
                  if (typeof window.Phone.InitSre === "function") {
                    try {
                      window.Phone.ShowDictionary("");
                    } catch (err) {
                      self.log("login showDictionary Error: " + err);
                      window.location.replace(response.url);
                    }
                  } else {
                    // 辞書WebViewの場合
                    self.$router.replace(route);
                  }
                }
              } else {
                window.location.replace(response.url);
              }
            }

            break;
          case "WARN_INPUT_PARAM":
          case "INFO_INVALID_USER":
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventLogin(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.error(constants.ERR_INVALID_USER);
            break;
          case "INFO_USER_LOCKED":
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventLogin(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.error(constants.ERR_USER_LOCKED);
            break;
          default:
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventLogin(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.error(constants.ERR_UNKNOWN);
            break;
        }
      }).catch(function(err) {
        // GoogleAnalyticsイベントヒット送信
        self.sendGaEventLogin(constants.GA_EVENT.ACTION.FAILURE, "ERR_UNKNOWN");

        self.error(constants.ERR_UNKNOWN);
      });
    },
    /**
     * エラー処理
     *
     * @param {String} message エラーメッセージ
     */
    error: function(message) {
      this.message = message;
      this.password = "";
    },
    /**
     * GoogleAnalyticsイベントヒット送信
     *
     * @param {String} eventAction イベントアクション
     * @param {String} resultCode WebAPI処理結果コード(未指定可)
     */
    sendGaEventLogin: function (eventAction, resultCode) {
      rosettaGA.sendEvent(
        constants.GA_EVENT.GATEGORY.LOGIN,
        eventAction,
        constants.GA_EVENT.LABEL.LOGIN,
        [null, resultCode]
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/login";
</style>



// WEBPACK FOOTER //
// Login.vue?09c55686